import React, {useRef, useState} from "react";
import styled from "styled-components";
import {HorizontalAlignment, VerticalAlignment} from "../../../utils/dom/DomUtils";
import {ReactUtils} from "../../utils/ReactUtils";
import CircleInformationIcon from "../icons/circle-information.svg?react";
import CircleQuestionIcon from "../icons/circle-question.svg?react";
import ErrorInfoIcon from "../icons/errorInfo.svg?react";
import {FlexCenterStyle, zIndex} from "../styles/styles";
import {colorPalette} from "../styles/colorPalette";
import GearIcon from "../icons/gear.svg?react";
import {InfoBubbleV5} from "./InfoBubbleV5";

interface IInfoButtonV5Props {
	readonly bubbleText: string | React.ReactNode;
	readonly isError?: boolean;
	readonly className?: "onPopup" | "leftAlign" | string;
	readonly icon?: "info" | "question-mark" | "error" | "gear";
	readonly iconStyle?: React.CSSProperties;
	readonly infoBubbleStyle?: React.CSSProperties;
	readonly verticalOpen?: VerticalAlignment.bottomOuter;
	readonly horizontalOpen?: HorizontalAlignment;
	readonly onClick?: () => void;
}

export const InfoButtonV5 = (props: IInfoButtonV5Props) => {
	const {infoBubbleStyle = {}, icon = "error", iconStyle = {}} = props;
	const _parentElement = useRef<HTMLDivElement>(null);
	const [isInfoBubbleOpen, setIsInfoBubbleOpen] = useState<boolean>(false);
	const [isFocus, setIsFocus] = useState<boolean>(false);

	const openBubble = () => {
		setIsInfoBubbleOpen(true);
		setIsFocus(true);
	};

	const closeBubble = () => {
		setIsInfoBubbleOpen(false);
		setIsFocus(false);
	};

	const inlineStyle: React.CSSProperties = {
		zIndex: zIndex.popup,
		...infoBubbleStyle,
	};

	const icons = {
		info: <CircleInformationIcon style={{height: "14px", width: "14px", ...iconStyle}} />,
		"question-mark": <CircleQuestionIcon />,
		error: <ErrorInfoIcon style={{height: "18px", width: "18px", ...iconStyle}} />,
		gear: <GearIcon style={{...iconStyle}} />,
	};

	return (
		<InfoButtonStyled
			ref={_parentElement}
			onMouseEnter={openBubble}
			onMouseLeave={closeBubble}
			onClick={props.onClick}
			className={ReactUtils.cls("InfoButtonV5", {isError: props.isError})}
		>
			{icons[icon]}
			{isInfoBubbleOpen && (
				<InfoBubbleV5
					content={props.bubbleText}
					isErrorMessage={props.isError}
					style={inlineStyle}
					className={`${props.className || ""} infobutton`}
					anchorRef={_parentElement}
					verticalAlignment={props.verticalOpen || VerticalAlignment.topOuter}
					horizontalAlignment={props.horizontalOpen || HorizontalAlignment.center}
					positionOffsetY={10}
					positionOffsetX={0}
					hide={!isFocus}
				/>
			)}
		</InfoButtonStyled>
	);
};

export const InfoButtonStyled = styled.div`
	${FlexCenterStyle}
	justify-content: center;
	position: relative;
	margin: 10px;

	svg {
		width: 18px;
		height: 18px;
		color: ${colorPalette.primary.c500Primary};
	}

	&.isError {
		svg {
			color: ${colorPalette.negative.c500Primary};
		}
	}
`;
